import PropTypes from 'prop-types';

import { LoaderSkeleton, OverlayTriggerTooltip, Pill } from '@utilities';
import { getPromptPillValue, getPromptPillTooltip } from '@helpers';
import { transformPromptSelections } from '../../../../../../pages/FastTracks/utilities/helpers.js';

import styles from './_index.module.scss';

const TitleSelectedPrompts = ({ answers, selectedPrompts }) => {
  if (!selectedPrompts?.length > 0 && answers) {
    return (
      <LoaderSkeleton height={40}>
        <rect height="22px" rx="8" ry="8" width="200px" x="0" y="15px" />
        <rect height="22px" rx="8" ry="8" width="200px" x="215px" y="15px" />
      </LoaderSkeleton>
    );
  }
  return (
    <div className={styles['title-selected-prompts']}>
      {selectedPrompts?.map((prompt, index) => {
        const answer = answers[prompt.promptKey];
        if (!answer) return null;
        const transformedAnswer = transformPromptSelections({ answers: answer, prompt });
        const answerValues = transformedAnswer.flatMap((item) => item.values);
        const value = getPromptPillValue({ answers: { [prompt.id]: answerValues }, prompt });
        const tooltip =
          prompt.id !== 'date_range'
            ? getPromptPillTooltip({
                answers: { [prompt.id]: answerValues },
                hasTooltip: true,
                prompt,
              })
            : '';
        return (
          <OverlayTriggerTooltip content={tooltip} key={`prompt-${index}`}>
            <Pill value={value} />
          </OverlayTriggerTooltip>
        );
      })}
    </div>
  );
};

TitleSelectedPrompts.propTypes = {
  answers: PropTypes.object.isRequired,
  selectedPrompts: PropTypes.array.isRequired,
};

export default TitleSelectedPrompts;
